const moment = require('moment');
const { min } = require('lodash');

export const createDate = date => (date ? moment(date).format('DD MMM YYYY') : null);
export const vehicleReqDate = (sources, format) => moment(min(sources.map(_obj => _obj.loading_date) || [])).format(format);
export const routeDetails = routeLocation => routeLocation.tooltip_text;
export const routeShortForm = routeLocation => routeLocation.route;
